<section class="content m-0 request-demo-section auth-page auth-page-wide">
  <div class="row m-0 py-2 request-demo-row">
    <div class="col-12 px-0 request-demo-header">
      <h1 class="title">Request a Demo</h1>
    </div>
    <div class="col-12 px-0">
      <form
        class="row m-0 request-demo-form needs-validation cx-standard-form"
        [formGroup]="demoForm"
        (ngSubmit)="onSubmit()"
      >
        <div class="row">
          <div class="col-md-6 px-0 pr-md-3">
            <div class="form-group request-demo-field">
              <label for="demoFullName"
                >Full Name <span class="text-danger">*</span></label
              >
              <input
                id="demoFullName"
                type="text"
                class="form-control"
                placeholder="Enter your full name"
                formControlName="fullName"
                [class.is-invalid]="
                  submitted && demoForm.get('fullName')?.errors
                "
              />
            </div>
          </div>
          <div class="col-md-6 px-0 pl-md-3">
            <div class="form-group request-demo-field">
              <label for="demoWorkEmail"
                >Work Email <span class="text-danger">*</span></label
              >
              <input
                id="demoWorkEmail"
                type="email"
                class="form-control"
                placeholder="name@organization.com"
                formControlName="workEmail"
                [class.is-invalid]="
                  submitted && demoForm.get('workEmail')?.errors
                "
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 px-0 pr-md-3">
            <div class="form-group request-demo-field">
              <label for="demoPhone">Phone</label>
              <input
                id="demoPhone"
                type="text"
                class="form-control min-width-20ch"
                placeholder="Enter number"
                mask="(000) 000-0000"
                inputmode="tel"
                formControlName="phone"
              />
            </div>
          </div>
          <div class="col-md-6 px-0 pl-md-3">
            <div class="form-group request-demo-field">
              <label for="demoRole"
                >Role / Title <span class="text-danger">*</span></label
              >
              <input
                id="demoRole"
                type="text"
                class="form-control"
                placeholder="Role / Title"
                formControlName="role"
                [class.is-invalid]="submitted && demoForm.get('role')?.errors"
              />
            </div>
          </div>
        </div>
        <div class="col-12 px-0">
          <div class="form-group request-demo-field">
            <label for="demoOrganization"
              >Organization / Office Name
              <span class="text-danger">*</span></label
            >
            <input
              id="demoOrganization"
              type="text"
              class="form-control"
              placeholder="Operations Manager, City Officer, Founder"
              formControlName="organization"
              [class.is-invalid]="
                submitted && demoForm.get('organization')?.errors
              "
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 px-0 pr-md-3">
            <div class="form-group request-demo-field">
              <label for="demoCountry">Country</label>
              <select
                id="demoCountry"
                class="form-control request-select-input"
                formControlName="country"
              >
                <option selected value="United States">United States</option>
              </select>
            </div>
          </div>
          <div class="col-md-4 px-0 px-md-2">
            <div class="form-group request-demo-field">
              <label for="demoState">State</label>
              <select
                id="demoState"
                class="form-control request-select-input"
                [class.request-select-placeholder]="
                  !demoForm.get('state')?.value
                "
                formControlName="state"
              >
                <option selected value="" disabled>Select state</option>
                <option
                  *ngFor="let state of statesList"
                  [value]="state.stateName"
                >
                  {{ state.stateName }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4 px-0 pl-md-3">
            <div class="form-group request-demo-field">
              <label for="demoCity">City / Jurisdiction</label>
              <input
                id="demoCity"
                type="text"
                class="form-control"
                placeholder="Enter city or jurisdiction"
                formControlName="city"
              />
            </div>
          </div>
        </div>
        <div class="col-12 px-0 mt-4">
          <button type="submit" class="btn btn-black w-100 request-demo-btn">
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</section>

<!----------------------------Demo-request-Modal----------------------------------->
<div
  class="modal fade demo-request-modal"
  tabindex="-1"
  role="dialog"
  id="demoRequestModal"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <p class="modal-title font-20 fw-600">Demo Request</p>
        <button
          type="button"
          class="close"
          aria-label="Close"
          data-dismiss="modal"
        >
          <span aria-hidden="true"
            ><app-icon
              name="x"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <p class="font-16 fw-400 mb-4 text-center">
          Your demo request has been submitted.
        </p>
        <div class="col-12 text-center">
          <button type="button" class="btn btn-black" (click)="onModalClose()">
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
